<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <panel-title icon="mdi-poll" :title="$t('ISTATISTIKLER.TITLE')" :desc="$t('ISTATISTIKLER.SUB_TITLE')" />
      </v-col>
      <v-col cols="12" class="py-0">
        <v-card class="rounded-lg">
          <v-card-text class="text-body-1 blue white--text">
            <v-icon size="18" dark left>mdi-chart-areaspline-variant</v-icon>
            {{ $t("ISTATISTIKLER.GENERAL_STATS_TITLE") }}
          </v-card-text>
          <div class="my-2"></div>
          <div class="d-flex justify-center pt-4">
            <v-btn-toggle v-if="isDesktop" v-model="toggleStats" mandatory dark>
              <v-btn color="blue" :value="key" small :key="key" v-for="(item, key) in daysList">{{ item }}</v-btn>
            </v-btn-toggle>
              <v-chip-group
                  v-else
                  mandatory
                  show-arrows
                  color="blue"
                  active-class="white--text blue"
                  v-model="toggleStats"
              >
                <v-chip
                    :key="key" v-for="(item, key) in daysList" :value="key"
                >
                  {{ item }}
                </v-chip>
              </v-chip-group>
          </div>
          <v-chart class="chart" :option="statsOptions" />
        </v-card>
      </v-col>
      <v-col cols="12" lg="4">
        <v-card class="rounded-lg">
          <v-card-text class="text-body-1 blue white--text d-flex align-center flex-wrap">
            <v-icon size="18" dark left>mdi-chart-areaspline-variant</v-icon>
            <span class="mr-2">{{ $t("ISTATISTIKLER.BROWSER_STATS_TITLE") }}</span>
            <v-spacer></v-spacer>
            <v-chip label small color="blue darken-3" dark>{{ daysList[toggleStats] }}</v-chip>
          </v-card-text>
          <div class="my-4"></div>
          <v-chart class="chart" :option="browserStatsOptions" />
        </v-card>
      </v-col>
      <v-col cols="12" lg="8">
        <v-card class="rounded-lg">
          <v-card-text class="text-body-1 blue white--text d-flex align-center flex-wrap">
            <v-icon size="18" dark left>mdi-chart-areaspline-variant</v-icon>
            <span class="mr-2">{{ $t("ISTATISTIKLER.PLATFORM_STATS_TITLE") }}</span>
            <v-spacer></v-spacer>
            <v-chip label small color="blue darken-3" dark>{{ daysList[toggleStats] }}</v-chip>
          </v-card-text>
          <div class="my-4"></div>
          <v-chart class="chart" :option="platformStatsOptions" />
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class="rounded-tl-lg rounded-tr-lg">
          <v-card-text class="text-body-1 blue white--text d-flex flex-wrap align-center">
            <div>
              <v-icon size="18" dark left>mdi-chart-areaspline-variant</v-icon>
              {{ $t("ISTATISTIKLER.STATS_LIST_TITLE") }}
            </div>
            <v-spacer></v-spacer>
            <v-sheet class="stats-select-limit" max-width="250" color="transparent">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small v-on="on" v-bind="attrs" color="white" class="blue--text text--darken-3 text-capitalize">
                    <v-icon size="17" class="mr-1">mdi-playlist-edit</v-icon>
                    {{
                      statsListLimit.value
                        ? ` ${$t("ISTATISTIKLER.STATS_LIST.SHOWING_TEXT", { COUNT: statsListLimit.value })}`
                        : $t("ISTATISTIKLER.STATS_LIST.SELECT_RANGE")
                    }}
                  </v-btn>
                </template>
                <v-list dense class="blue lighten-5">
                  <v-list-item click :key="key" v-for="(item, key) in statsListLimit.items" @click="statsListLimit.value = item.value">
                    <v-list-item-content></v-list-item-content>
                    <v-list-item-action class="text-caption font-weight-bold blue--text text--darken-2 justify-end" v-text="item.text"></v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-sheet>
          </v-card-text>
        </v-card>
        <v-data-table
          :items="statsTable.statsList"
          :page.sync="tableParams.page"
          :items-per-page="list.limit"
          :headers="statsTable.headers"
          :no-data-text="statsTable.noDataText"
          calculate-widths
          hide-default-footer
          class="elevation-1 mb-3"
          @page-count="tableParams.pageCount = $event"
          :loading="tableParams.listStatus"
          :loading-text="statsTable.loadingText"
          :server-items-length="statsTable.statsCount"
        >
          <template v-slot:[`item.index`]="{ item }">
            <span class="text-overline">{{ String(item.index) }}</span>
          </template>
          <template v-slot:[`item.ip`]="{ item }">
            <span class="text-overline">{{ String(item.ip) }}</span>
          </template>
          <template v-slot:[`item.is`]="{ item }">
            <span v-if="item.is == 'D'">
              <v-icon size="18" class="mr-1">mdi-monitor</v-icon>
            </span>
            <span v-else-if="item.is == 'T'">
              <v-icon size="18" class="mr-1">mdi-tablet</v-icon>
            </span>
            <span v-else-if="item.is == 'M'">
              <v-icon size="18" class="mr-1">mdi-cellphone</v-icon>
            </span>
            <span v-else-if="item.is == 'F'">
              <v-icon size="18" class="mr-1">mdi-facebook</v-icon>
            </span>
            <span v-else-if="item.is == 'R'">
              <v-icon size="18" class="mr-1">mdi-robot</v-icon>
            </span>
            <span class="font-weight-medium">{{ platformTypes[item.is] }}</span>
          </template>
          <template v-slot:[`item.platform`]="{ item }">
            <span v-if="item.platform == 'Linux'">
              <v-icon size="18" class="mr-1">mdi-linux</v-icon>
            </span>
            <span v-else-if="item.platform == 'Windows'">
              <v-icon size="18" class="mr-1">mdi-microsoft-windows</v-icon>
            </span>
            <span v-else-if="item.platform == 'Apple'">
              <v-icon size="18" class="mr-1">mdi-apple</v-icon>
            </span>
            <span v-else-if="item.platform == 'Unknown'">
              <v-icon size="18" class="mr-1">mdi-help-rhombus</v-icon>
            </span>
            <span v-else-if="item.platform == 'Chrome OS'">
              <v-icon size="18" class="mr-1">mdi-google-chrome</v-icon>
            </span>
            <span v-else-if="item.platform == 'Apple TV'">
              <v-icon size="18" class="mr-1">mdi-apple</v-icon>
            </span>
            <span v-else-if="item.platform == 'SMART-TV'">
              <v-icon size="18" class="mr-1">mdi-television</v-icon>
            </span>
            <span v-else-if="item.platform == 'Sony PlayStation'">
              <v-icon size="18" class="mr-1">mdi-sony-playstation</v-icon>
            </span>
            <span v-else-if="item.platform == 'Android'">
              <v-icon size="18" class="mr-1">mdi-android</v-icon>
            </span>
            {{ item.platform }}
          </template>
          <template v-slot:[`item.browser`]="{ item }">
            <span v-if="item.browser == 'Chrome'">
              <v-icon size="18" class="mr-1">mdi-google-chrome</v-icon>
            </span>
            <span v-else-if="item.browser == 'Android'">
              <v-icon size="18" class="mr-1">mdi-android</v-icon>
            </span>
            <span v-else-if="item.browser == 'Safari'">
              <v-icon size="18" class="mr-1">mdi-apple-safari</v-icon>
            </span>
            <span v-else-if="item.browser == 'iPhone'">
              <v-icon size="18" class="mr-1">mdi-apple-ios</v-icon>
            </span>
            <span v-else-if="item.browser == 'Opera' || item.browser == 'Opera Mini'">
              <v-icon size="18" class="mr-1">mdi-opera</v-icon>
            </span>
            <span v-else-if="item.browser == 'Edge'">
              <v-icon size="18" class="mr-1">mdi-microsoft-edge</v-icon>
            </span>
            <span v-else-if="item.browser == 'Internet Explorer'">
              <v-icon size="18" class="mr-1">mdi-microsoft-internet-explorer</v-icon>
            </span>
            <span v-else-if="item.browser == 'Firefox' || item.browser == 'Mozilla'">
              <v-icon size="18" class="mr-1">mdi-firefox</v-icon>
            </span>
            <span v-else-if="item.browser == 'iPod'">
              <v-icon size="18" class="mr-1">mdi-ipod</v-icon>
            </span>
            {{ item.browser }}
          </template>
          <template v-slot:[`item.target`]="{ item }">{{ item.target.slice(0, 1) !== "/" ? "/" : null }}{{ item.target }} </template>
          <template v-slot:[`item.router`]="{ item }">
            <v-chip label>{{ item.router }}</v-chip>
          </template>
          <template v-slot:[`item.date`]="{ item }">
            {{ $dayjs(item.date).format('ddd DD MMM YYYY hh:mm A') }}
          </template>

        </v-data-table>
        <v-pagination v-model="pagination.page" :length="30" circle @input="pageClick"></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PanelTitle from "../../../components/PanelTitle.vue";

import { use } from "echarts/core";
import { CanvasRenderer, SVGRenderer } from "echarts/renderers";

import { BarChart, LineChart, PieChart, MapChart, RadarChart, ScatterChart, EffectScatterChart, LinesChart } from "echarts/charts";
import {
  GridComponent,
  PolarComponent,
  GeoComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  VisualMapComponent,
  DatasetComponent,
  ToolboxComponent,
  DataZoomComponent
} from "echarts/components";
import VChart from "vue-echarts";

use([
  BarChart,
  LineChart,
  PieChart,
  MapChart,
  RadarChart,
  ScatterChart,
  EffectScatterChart,
  LinesChart,
  GridComponent,
  PolarComponent,
  GeoComponent,
  TooltipComponent,
  LegendComponent,
  TitleComponent,
  VisualMapComponent,
  DatasetComponent,
  CanvasRenderer,
  SVGRenderer,
  ToolboxComponent,
  DataZoomComponent
]);

import IstatistiklerService from "@/services/IstatistiklerService";

export default {
  name: "IstatistikDetay",
  components: { PanelTitle, VChart },
  data() {
    return {
      daysLimits: {
        today: 1,
        "10 days": 10,
        "20 days": 20,
        "30 days": 30,
        "3 months": 3 * 30,
        "6 months": 6 * 30,
        "9 months": 9 * 30,
        "1 year": 365
      },
      daysList: {
        today: this.$t("ISTATISTIKLER.TODAY"),
        "10 days": this.$t("ISTATISTIKLER.DAYS_LIST.TEN_DAYS"),
        "20 days": this.$t("ISTATISTIKLER.DAYS_LIST.TWENTY_DAYS"),
        "30 days": this.$t("ISTATISTIKLER.DAYS_LIST.THIRTY_DAYS"),
        "3 months": this.$t("ISTATISTIKLER.DAYS_LIST.THREE_MONTHS"),
        "6 months": this.$t("ISTATISTIKLER.DAYS_LIST.SIX_MONTHS"),
        "9 months": this.$t("ISTATISTIKLER.DAYS_LIST.NINE_MONTHS"),
        "1 year": this.$t("ISTATISTIKLER.DAYS_LIST.LAST_YEAR")
      },
      toggleStats: "",
      statsOptions: {
        animationDuration: 1000,
        title: {
          left: "left"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            label: {
              formatter: this.$t("ISTATISTIKLER.VISITOR_NUMBER")
            }
          }
        },
        legend: {
          data: [this.$t("ISTATISTIKLER.TODAY")]
        },
        xAxis: {
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value",
          minInterval: 1
        },
        series: [
          {
            data: [150, 230, 224, 218, 135, 147, 260],
            type: "line"
          }
        ]
      },
      browserStatsOptions: {
        center: ["50%", "50%"],
        tooltip: {
          trigger: "item"
        },
        legend: {
          top: "1%",
          left: "center",
          itemGap: 20
        },
        animationDurationTypeUpdate: "expansion",
        series: [
          {
            name: this.$t("ISTATISTIKLER.BROWSER_STATS_TITLE"),
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "30"
              }
            },
            labelLine: {
              show: false
            },
            data: [
              { value: 580, name: this.$t("ISTATISTIKLER.BROWSERS.CHROME") },
              { value: 735, name: this.$t("ISTATISTIKLER.BROWSERS.FIREFOX") },
              { value: 1048, name: this.$t("ISTATISTIKLER.BROWSERS.SAFARI") },
              { value: 484, name: this.$t("ISTATISTIKLER.BROWSERS.OPERA") },
              { value: 300, name: this.$t("ISTATISTIKLER.BROWSERS.INTERNET_EXPLORER") }
            ]
          }
        ]
      },
      platformStatsOptions: {
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: [
            this.$t("ISTATISTIKLER.LEGENDS.DESKTOP"),
            this.$t("ISTATISTIKLER.LEGENDS.MOBILE"),
            this.$t("ISTATISTIKLER.LEGENDS.TABLET"),
            this.$t("ISTATISTIKLER.LEGENDS.ROBOT"),
            this.$t("ISTATISTIKLER.LEGENDS.FACEBOOK")
          ]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: "value",
          minInterval: 1
        },
        series: [
          {
            name: this.$t("ISTATISTIKLER.LEGENDS.DESKTOP"),
            type: "line",
            stack: "总量",
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: this.$t("ISTATISTIKLER.LEGENDS.MOBILE"),
            type: "line",
            stack: "总量",
            data: [220, 182, 191, 234, 290, 330, 50]
          },
          {
            name: this.$t("ISTATISTIKLER.LEGENDS.TABLET"),
            type: "line",
            stack: "总量",
            data: [150, 232, 201, 154, 190, 330, 410]
          },
          {
            name: this.$t("ISTATISTIKLER.LEGENDS.ROBOT"),
            type: "line",
            stack: "总量",
            data: [320, 332, 301, 334, 390, 330, 320]
          },
          {
            name: this.$t("ISTATISTIKLER.LEGENDS.FACEBOOK"),
            type: "line",
            stack: "总量",
            data: [820, 932, 901, 934, 1290, 1330, 1320]
          }
        ]
      },
      platformTypes: {
        D: this.$t("ISTATISTIKLER.LEGENDS.DESKTOP"),
        T: this.$t("ISTATISTIKLER.LEGENDS.TABLET"),
        M: this.$t("ISTATISTIKLER.LEGENDS.MOBILE"),
        R: this.$t("ISTATISTIKLER.LEGENDS.ROBOT"),
        F: this.$t("ISTATISTIKLER.LEGENDS.FACEBOOK")
      },
      statsTable: {
        headers: [
          {
            text: "#",
            align: "start",
            sortable: false,
            value: "index"
          },
          {
            text: this.$t("ISTATISTIKLER.STATS_LIST.TABLE_FIELDS.IP"),
            sortable: false,
            value: "ip"
          },
          { text: this.$t("ISTATISTIKLER.STATS_LIST.TABLE_FIELDS.PLATFORM"), value: "is", sortable: false },
          { text: this.$t("ISTATISTIKLER.STATS_LIST.TABLE_FIELDS.OPERATING_SYSTEM"), value: "platform", sortable: false },
          { text: this.$t("ISTATISTIKLER.STATS_LIST.TABLE_FIELDS.BROWSER"), value: "browser", sortable: false },
          { text: this.$t("ISTATISTIKLER.STATS_LIST.TABLE_FIELDS.TARGET"), value: "target", sortable: false },
          { text: this.$t("ISTATISTIKLER.STATS_LIST.TABLE_FIELDS.REDIRECT"), value: "router", sortable: false },
          { text: this.$t("ISTATISTIKLER.STATS_LIST.TABLE_FIELDS.DATE"), value: "date", sortable: false }
        ],
        noDataText: this.$t("ISTATISTIKLER.NO_STATS_FOUND"),
        loadingText: this.$t("ISTATISTIKLER.LOADING_STATS"),
        statsList: [],
        statsCount: 0
      },
      pagination: {
        page: 1,
        lastPage: 0
      },
      tableParams: {
        page: 1,
        pageCount: 0,
        listStatus: true
      },
      list: {
        start: 0,
        limit: 15
      },
      statsListLimit: {
        items: [
          { text: "7", value: 7 },
          { text: "15", value: 15 },
          { text: "30", value: 30 },
          { text: "50", value: 50 },
          { text: "100", value: 100 }
        ],
        value: 15
      }
    };
  },
  computed: {
    isDesktop() {
      return this.$vuetify.breakpoint.lgAndUp;
    }
  },
  methods: {
    pageClick(page) {
      if (page !== this.pagination.lastPage) {
        /**
         * Başlangıç değerini pagination'a göre ayarla
         */
        this.list.start = this.pagination.page * this.list.limit - this.list.limit;

        this.statsList();
      }
    },
    statsList() {
      const { start, limit } = this.list;
      this.tableParams.listStatus = true;
      IstatistiklerService.getStatsList({ start, limit })
        .then(res => {
          let list = res.data.list.map((d, i) => {
              d.index = i + 1 + this.list.start;
              return d;
            }),
            count = res.data.count;
          if (res.status === 200) {
            this.$set(this.statsTable, "statsList", list);
            this.$set(this.statsTable, "statsCount", count);
          }
        })
        .then(() => {
          this.tableParams.listStatus = false;
        });
    },
    timeLineHour(list) {
      let timeLine = [];
      for (let i = 0; i < 24; i++) {
        timeLine.push(String(i).padStart("2", "0"));
      }

      let statsList = [];
      list.forEach(item => {
        statsList.push(String(new Date(item.date).getHours()).padStart("2", "0"));
      });

      let countList = [];
      timeLine.forEach(item => {
        countList.push(
          statsList.reduce(function(n, val) {
            return n + (val === item);
          }, 0)
        );
      });
      return countList;
      // let seconds = a.getSeconds(),
      // minutes = a.getMinutes(),
      // hour = a.getHours();
      // String(hour).padStart("2", "0") + ":" + String(minutes).padStart("2", "0") + ":" + String(seconds).padStart("2", "0")
    },
    timeLineYear(list) {
      let timeLine = [];
      for (let i = 0; i < 12; i++) {
        let date = new Date(),
          newDate = date.setMonth(date.getMonth() - i),
          setDate = new Date(newDate);

        timeLine.push("01-" + String(setDate.getMonth() + 1).padStart("2", "0") + "-" + setDate.getFullYear());
      }
      timeLine.reverse();

      let statsList = [];
      list.forEach(item => {
        statsList.push("01-" + String(new Date(item.date).getMonth() + 1).padStart("2", "0") + "-" + new Date(item.date).getFullYear());
      });

      let countList = [];
      timeLine.forEach(item => {
        countList.push(
          statsList.reduce(function(n, val) {
            return n + (val === item);
          }, 0)
        );
      });
      return {
        values: countList,
        legend: timeLine
      };
    },
    timeLineMonth(list, length) {
      let timeLine = [];
      for (let i = 0; i < length; i++) {
        let date = new Date(),
          newDate = date.setMonth(date.getMonth() - i),
          setDate = new Date(newDate);

        timeLine.push("01-" + String(setDate.getMonth() + 1).padStart("2", "0") + "-" + setDate.getFullYear());
      }
      timeLine.reverse();

      let statsList = [];
      list.forEach(item => {
        statsList.push("01-" + String(new Date(item.date).getMonth() + 1).padStart("2", "0") + "-" + new Date(item.date).getFullYear());
      });

      let countList = [];
      timeLine.forEach(item => {
        countList.push(
          statsList.reduce(function(n, val) {
            return n + (val === item);
          }, 0)
        );
      });
      return {
        values: countList,
        legend: timeLine
      };
    },
    timeLineDays(list, days) {
      let timeLine = [];
      for (let i = 0; i < days; i++) {
        timeLine.push(new Date(Date.now() - 86400000 * i).toISOString().slice(0, 10));
      }
      timeLine = timeLine.reverse();

      let statsList = [];
      list.forEach(item => {
        statsList.push(new Date(item.date).toISOString().slice(0, 10));
      });

      let countList = [];
      timeLine.forEach(item => {
        countList.push(
          statsList.reduce(function(n, val) {
            return n + (val === item);
          }, 0)
        );
      });
      return countList;
    }
  },
  created() {
    this.statsList();
  },
  watch: {
    toggleStats: {
      handler(val) {
        let stats = val;
        IstatistiklerService.getStatsAll({ stats })
          .then(res => {
            if (res.status === 200) {
              if (val === "today") {
                let series = this.timeLineHour(res.data),
                  axisData = series.map((d, i) => {
                    return String(i).padStart("2", "0") + ":" + "00";
                  });
                this.statsOptions.xAxis.data = axisData;
                this.statsOptions.series[0].data = series;
              } else if (val === "1 year") {
                let series = this.timeLineYear(res.data),
                  axisData = series.legend.map(d => {
                    return d;
                  });
                this.statsOptions.xAxis.data = axisData;
                this.statsOptions.series[0].data = series.values;
              } else if (val.match("month") !== null) {
                let series = this.timeLineMonth(res.data, Number(val.slice(0, 1))),
                  axisData = series.legend.map(d => {
                    return d;
                  });
                this.statsOptions.xAxis.data = axisData;
                this.statsOptions.series[0].data = series.values;
              } else {
                let series = this.timeLineDays(res.data, this.daysLimits[val]),
                  axisData = series.map((d, i) => {
                    return this.$t("ISTATISTIKLER.DAY_TH", { NUMBER: i + 1 });
                  });
                this.statsOptions.xAxis.data = axisData;
                this.statsOptions.series[0].data = series;
              }
              return res.data;
            }
          })
          .then(list => {
            /**
             * Platform İstatistikleri
             */
            if (list) {
              let platformList = {};
              list.forEach(item => {
                if (!Object.hasOwnProperty.call(platformList, this.platformTypes[item.is])) {
                  platformList[this.platformTypes[item.is]] = [];
                }
                platformList[this.platformTypes[item.is]].push(item);
              });

              for (let i in this.platformTypes) {
                if (!Object.hasOwnProperty.call(platformList, this.platformTypes[i])) {
                  platformList[this.platformTypes[i]] = [];
                }
              }
              let count = 0;
              Object.keys(platformList).forEach(key => {
                if (this.daysLimits[val] === 1) {
                  let series = this.timeLineHour(platformList[key]),
                    axisData = series.map((d, i) => {
                      return String(i).padStart("2", "0") + ":" + "00";
                    });
                  this.platformStatsOptions.xAxis.data = axisData;
                  this.platformStatsOptions.series[count].data = series;
                  if (platformList[key].length === 0) {
                    // this.platformStatsOptions.legend.show = false;
                  }
                } else {
                  let series = this.timeLineDays(platformList[key], this.daysLimits[val]),
                    axisData = series.map((d, i) => {
                      return i + 1 + ".gün";
                    });
                  this.platformStatsOptions.xAxis.data = axisData;
                  this.platformStatsOptions.series[count].data = series;
                  if (platformList[key].length === 0) {
                    // this.platformStatsOptions.legend.show = false;
                  }
                }
                count++;
              });
            }
          });

        /**
         * Istatistikkler Pie İçin Browser İstatistikleri
         */
        IstatistiklerService.getBrowserStats({ stats }).then(res => {
          if (res.status === 200) {
            let acceptBrowsers = this.browserStatsOptions.series[0].data,
              browserList = res.data,
              browsers = browserList.map(b => b.browser),
              browsersData = browserList.map(b => b.total);

            let browserPie = [];
            Object.keys(acceptBrowsers).map(x => {
              let seriesData = acceptBrowsers[x];
              if (browsers.includes(seriesData.name)) {
                browserPie.push({
                  name: seriesData.name,
                  value: browsersData[browsers.indexOf(seriesData.name)]
                });
              } else {
                browserPie.push({
                  name: seriesData.name,
                  value: 0
                });
              }
            });
            this.browserStatsOptions.series[0].data = browserPie;
          }
        });
      }
    },
    "pagination.page": {
      handler(page) {
        this.pagination.lastPage = page;
      },
      immediate: true
    },
    "statsListLimit.value"(val) {
      Promise.resolve((this.list.limit = val)).then(() => this.statsList());
    }
  }
};
</script>

<style>
.chart {
  height: 400px;
}
</style>
